__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "container";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@allmysons/store", "1.1.0", () => (() => (__webpack_require__(2460))), 1);
			register("@emotion/react", "11.14.0", () => (() => (__webpack_require__(7691))), 1);
			register("@emotion/styled", "11.14.1", () => (() => (__webpack_require__(4072))), 1);
			register("@mui/material", "5.18.0", () => (() => (__webpack_require__(9726))), 1);
			register("@mui/styles", "5.18.0", () => (() => (__webpack_require__(7157))), 1);
			register("@posthog/react", "1.10.0", () => (() => (__webpack_require__(4686))), 1);
			register("@reduxjs/toolkit", "2.10.1", () => (() => (__webpack_require__(1439))), 1);
			register("posthog-js", "1.379.3", () => (() => (__webpack_require__(5432))), 1);
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(8485))), 1);
			register("react-redux", "7.2.9", () => (() => (__webpack_require__(9445))), 1);
			register("react-router", "7.9.6", () => (() => (__webpack_require__(7182))), 1);
			register("react", "18.3.1", () => (() => (__webpack_require__(7552))), 1);
			register("redux-persist", "6.0.0", () => (() => (__webpack_require__(933))), 1);
			initExternal(7652);
			initExternal(2296);
			initExternal(8606);
			initExternal(980);
			initExternal(1643);
			initExternal(2096);
			initExternal(5802);
			initExternal(5570);
			initExternal(4014);
			initExternal(2216);
			initExternal(6106);
			initExternal(8516);
			initExternal(7768);
			initExternal(2340);
			initExternal(5042);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};